import React from 'react'
// ##
import UnitsReportView from '../../modules/OrdersReportView/components/UnitsReport'

export default function UnitsReportPage() {
  return <UnitsReportView />
}
